import { useMutation } from "react-query";
import API from "../../Config/axios";
import omit from "lodash/omit";

const onDoctorArrived = async (payload) => {
  const { data } = await API.post(
    `/shifts/${payload.shiftId}`,
    omit(payload, "shiftId")
  );
  return data;
};

const useDoctorArrived = () => {
  return useMutation((payload) => onDoctorArrived(payload));
};

export default useDoctorArrived;
